import { Shape } from '@material-ui/core/styles/shape';

export default { borderRadius: 6 } as Shape;
